import { useQuery } from "@tanstack/react-query";
import { Issuer, IssuersService } from "api/generated/cms";
import { CMS_QUERY_OPTIONS } from "./cmsQueryOptions";
import "./cmsClient";

export const useGetCmsIssuerByExternalId = (
  externalId: number | undefined
) => {
  const { isInitialLoading, error, data } = useQuery<Issuer, Error>(
    ["cms", "issuer", "externalId", externalId],
    () =>
      IssuersService.getApiV1IssuersByExternalId({
        externalId: externalId as number,
      }),
    {
      ...CMS_QUERY_OPTIONS,
      enabled: externalId !== undefined && Number.isFinite(externalId),
    }
  );
  return { loading: isInitialLoading, error, data };
};
